import Component from './find-your-car.component'

export { default as ConvertiblesIcon } from './icons/convertibles.svg'
export { default as CoupesIcon } from './icons/coupes.svg'
export { default as EstatesIcon } from './icons/estates.svg'
export { default as HatchbacksIcon } from './icons/hatchbacks.svg'
export { default as SuvsIcon } from './icons/suvs.svg'

export default Component
